module.exports = __webpack_public_path__ + "static/media/no_data.b297b81d.svg";